function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var S = Object.defineProperty;
var L = (e, n, t)=>n in e ? S(e, n, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : e[n] = t;
var g = (e, n, t)=>(L(e, typeof n != "symbol" ? n + "" : n, t), t);
import * as s from "react";
import T from "classnames";
import { ButtonDanger as W, ButtonPrimary as M, ButtonSecondary as O } from "./button.js";
import { Portal as I } from "./portal.js";
import H from "./focus-trap.js";
import F from "./generated/mistica-icons/icon-close-regular.js";
import V from "./icon-button.js";
import { isWebViewBridgeAvailable as j, nativeConfirm as K, nativeAlert as _ } from "@tef-novum/webview-bridge";
import z from "./theme-context.js";
import { useTheme as D } from "./hooks.js";
import U from "./button-layout.js";
import { Text5 as q, Text4 as P, Text3 as G } from "./text.js";
import { ESC as J } from "./utils/key-codes.js";
import E from "./box.js";
import { isOldChrome as Q, isRunningAcceptanceTest as X } from "./utils/platform.js";
import { useSetModalState as Y } from "./modal-context-provider.js";
import Z from "./stack.js";
import { wrapper as $, modalOpacityLayer as ee, closedOpactityLayer as te, modalContent as oe, closedModalContent as ne, modalCloseButtonContainer as ae, variants as ie, iconContainer as le, dialogContent as se, dialogActions as ce } from "./dialog.css-mistica.js";
import { vars as R } from "./skins/skin-contract.css-mistica.js";
import { jsx as o, jsxs as b, Fragment as re } from "./_virtual/jsx-runtime.js";
const A = (e)=>!Q(e) && process.env.NODE_ENV !== "test" && !X(e), de = (e)=>{
    const { texts: n  } = D(), { className: t , title: a , message: c , icon: l , extra: i , cancelText: r = n.dialogCancelButton , acceptText: d = n.dialogAcceptButton , onCancel: u , onAccept: C , showCancel: p = !1 , destructive: h = !1  } = e, x = !!e.forceWeb, m = {
        onPress: C || (()=>{}),
        dataAttributes: {
            testid: "dialog-accept-button"
        },
        children: d
    };
    return /* @__PURE__ */ b("div", {
        className: T(ie[x ? "dialog" : "default"], t),
        children: [
            l && /* @__PURE__ */ o(E, {
                paddingBottom: 24,
                children: /* @__PURE__ */ o("div", {
                    className: le,
                    children: /*#__PURE__*/ s.cloneElement(l, {
                        size: "100%"
                    })
                })
            }),
            a && /* @__PURE__ */ o(E, {
                paddingBottom: 16,
                children: e.forceWeb ? /* @__PURE__ */ o(q, {
                    as: "h2",
                    children: a
                }) : /* @__PURE__ */ o(P, {
                    regular: !0,
                    as: "h2",
                    children: a
                })
            }),
            e.subtitle && /* @__PURE__ */ o(E, {
                paddingBottom: 16,
                children: /* @__PURE__ */ o(P, {
                    regular: !0,
                    as: "h2",
                    children: e.subtitle
                })
            }),
            /* @__PURE__ */ o("div", {
                className: se,
                children: /* @__PURE__ */ b(Z, {
                    space: 16,
                    children: [
                        /* @__PURE__ */ o(G, {
                            color: R.colors.textSecondary,
                            regular: !0,
                            children: c
                        }),
                        i
                    ]
                })
            }),
            /* @__PURE__ */ o("div", {
                className: ce,
                children: /* @__PURE__ */ b(U, {
                    link: e.forceWeb ? e.link : void 0,
                    children: [
                        h ? /* @__PURE__ */ o(W, _objectSpread({
                            tabIndex: 1
                        }, m)) : /* @__PURE__ */ o(M, _objectSpread({
                            tabIndex: 1
                        }, m)),
                        p && !!u && /* @__PURE__ */ o(O, {
                            tabIndex: 2,
                            onPress: u,
                            dataAttributes: {
                                testid: "dialog-cancel-button"
                            },
                            children: r
                        })
                    ]
                })
            })
        ]
    });
}, ue = (param)=>{
    let { showCancel: e , message: n , title: t , acceptText: a , cancelText: c , onAccept: l , onCancel: i  } = param;
    return e ? K({
        message: n,
        title: t,
        cancelText: c,
        acceptText: a
    }).then((r)=>r ? l == null ? void 0 : l() : i == null ? void 0 : i()) : _({
        message: n,
        title: t,
        buttonText: a
    }).then(l);
}, he = (param)=>{
    let { renderNative: e , onAccept: n , onCancel: t , acceptText: a , cancelText: c , showCancel: l , message: i , title: r  } = param;
    const d = s.useRef(n).current, u = s.useRef(t).current;
    s.useEffect(()=>{
        e && ue({
            acceptText: a,
            cancelText: c,
            showCancel: l,
            message: i,
            title: r,
            onAccept: d,
            onCancel: u
        });
    }, [
        d,
        u,
        a,
        c,
        l,
        i,
        r,
        e
    ]);
}, me = (e)=>(he({
        renderNative: !0,
        acceptText: e.acceptText || e.dialogAcceptButton,
        cancelText: e.cancelText || e.dialogCancelButton,
        showCancel: e.showCancel,
        message: e.message,
        title: e.title,
        onAccept: e.onAccept,
        onCancel: e.onCancel
    }), null), fe = (e)=>{
    var N;
    const { platformOverrides: n  } = D(), t = s.useContext(z), a = s.useRef(process.env.NODE_ENV === "test");
    if (!t) throw Error("To use @telefonica/mistica components you must instantiate <ThemeContextProvider> as their parent.");
    const c = !e.forceWeb && j(), { onAccept: l , isClosing: i , onCancel: r , onCloseTransitionEnd: d  } = e, u = _objectWithoutProperties(e, [
        "onAccept",
        "isClosing",
        "onCancel",
        "onCloseTransitionEnd"
    ]), C = s.useCallback(()=>{
        !i && a.current && l();
    }, [
        i,
        l
    ]), p = s.useCallback(()=>{
        !i && a.current && r();
    }, [
        i,
        r
    ]), h = e.showCancel ? p : C, x = s.useCallback((f)=>{
        e.showClose && (h(), f.stopPropagation());
    }, [
        h,
        e.showClose
    ]), m = s.useCallback((f)=>{
        f.keyCode === J && (h(), f.stopPropagation(), f.preventDefault());
    }, [
        h
    ]), B = s.useCallback(()=>{
        document.addEventListener("keydown", m);
    }, [
        m
    ]);
    s.useEffect(()=>(A(n) || B(), (c || !A(n)) && e.isClosing && e.onCloseTransitionEnd && e.onCloseTransitionEnd(), ()=>{
            document.removeEventListener("keydown", m);
        }), [
        B,
        m,
        e,
        c,
        n
    ]);
    const k = Y();
    return s.useEffect(()=>(k({
            isModalOpen: !0
        }), ()=>{
            k({
                isModalOpen: !1
            });
        }), [
        k
    ]), c ? /* @__PURE__ */ o(me, _objectSpreadProps(_objectSpread({}, e), {
        dialogAcceptButton: t.texts.dialogAcceptButton,
        dialogCancelButton: t.texts.dialogCancelButton
    })) : /* @__PURE__ */ o(I, {
        children: /* @__PURE__ */ o("div", {
            className: $,
            children: /* @__PURE__ */ o(H, {
                children: /* @__PURE__ */ o("div", {
                    onClick: x,
                    className: T(ee, {
                        [te]: i
                    }),
                    role: "dialog",
                    "data-component-name": "Dialog",
                    children: /* @__PURE__ */ o("div", {
                        onClick: (f)=>f.stopPropagation(),
                        children: /* @__PURE__ */ b("div", {
                            onTransitionEnd: i && d ? d : void 0,
                            onAnimationEnd: ()=>{
                                a.current = !0, B();
                            },
                            className: T(oe, {
                                [ne]: i
                            }),
                            children: [
                                e.showClose && /* @__PURE__ */ o("div", {
                                    className: ae,
                                    children: /* @__PURE__ */ o(V, {
                                        onPress: h,
                                        "aria-label": (N = t.texts.modalClose) != null ? N : t.texts.closeButtonLabel,
                                        children: /* @__PURE__ */ o(F, {
                                            color: R.colors.neutralHigh
                                        })
                                    })
                                }),
                                /* @__PURE__ */ o(de, _objectSpreadProps(_objectSpread({}, u), {
                                    onCancel: p,
                                    onAccept: C
                                }))
                            ]
                        })
                    })
                })
            })
        })
    });
};
let v = null, w = 0;
class Me extends s.Component {
    componentDidMount() {
        w++, w === 1 && (v = this, window.addEventListener("popstate", this.handleBack));
    }
    componentWillUnmount() {
        w--, w === 0 && (v = null, window.removeEventListener("popstate", this.handleBack));
    }
    show(t) {
        if (this.state.dialogProps) throw Error("Tried to show a dialog on top of another dialog. This functionality is not currently supported.");
        window.history.pushState(null, document.title, window.location.href), this.setState({
            dialogProps: t,
            isClosing: !1
        });
    }
    close() {
        window.history.back();
    }
    createCancelHandler(t) {
        return ()=>{
            t && (this.callback = ()=>t()), this.close();
        };
    }
    createAcceptHandler(t) {
        return ()=>{
            t && (this.callback = ()=>t()), this.close();
        };
    }
    render() {
        const { isClosing: t , dialogProps: a  } = this.state;
        let c = null;
        if (a && this.state.instanceNumber === 1) {
            const { onCancel: l , onAccept: i  } = a, r = _objectWithoutProperties(a, [
                "onCancel",
                "onAccept"
            ]);
            c = /* @__PURE__ */ o(fe, _objectSpread({
                onCancel: this.createCancelHandler(l),
                onAccept: this.createAcceptHandler(i),
                isClosing: t,
                onCloseTransitionEnd: t ? this.handleCloseFinished : void 0
            }, r));
        }
        return /* @__PURE__ */ b(re, {
            children: [
                this.props.children,
                c
            ]
        });
    }
    constructor(){
        super(...arguments);
        g(this, "state", {
            dialogProps: null,
            isClosing: !1,
            instanceNumber: w + 1
        });
        g(this, "callback", null);
        g(this, "handleCloseFinished", ()=>{
            this.setState({
                dialogProps: null,
                isClosing: !1
            });
        });
        g(this, "handleBack", ()=>{
            var t;
            this.state.dialogProps && ((t = this.callback) == null || t.call(this), this.callback = null, this.setState({
                isClosing: !0
            }));
        });
    }
}
const y = (param)=>{
    let { showCancel: e , showClose: n , forceWeb: t  } = param;
    return (a)=>{
        if (!v) throw Error("Tried to show a dialog but the DialogRoot component was not mounted (mount <ThemeContextProvider>)");
        v.show(_objectSpread({
            showCancel: e,
            showClose: n,
            forceWeb: t
        }, a));
    };
}, Oe = y({
    showCancel: !1,
    forceWeb: !1,
    showClose: !1
}), Ie = y({
    showCancel: !0,
    forceWeb: !1,
    showClose: !1
}), He = y({
    showCancel: !1,
    forceWeb: !0,
    showClose: !0
});
export { Oe as alert, Ie as confirm, Me as default, He as dialog };
